import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

type DefaultColorsProps = {
  activeColor: string;
  colorHandler: (color: string) => void;
};

const DefaultColors = ({
  activeColor,
  colorHandler,
}: DefaultColorsProps): React.JSX.Element => {
  const colorsList = [
    "#A52A2A",
    "#3F51B5",
    "#8E24AA",
    "#219711",
    "#FF0000",
    "#FF5AC4",
    "#008080",
    "#FF6F00",
    "#FBC02D",
    "#0288D1",
    "#5D4037",
    "#333333",
  ];

  return (
    <div className='grid grid-cols-6 gap-2'>
      {colorsList.map((color) => (
        <div
          className={cn(
            "ease-in-out duration-200 h-8 border rounded-sm hover:cursor-pointer active:scale-95 flex justify-center items-center",
          )}
          key={color}
          style={{
            backgroundColor: color,
          }}
          onClick={() => {
            if (color === activeColor) {
              colorHandler("");

              return;
            }
            colorHandler(color);
          }}
        >
          {activeColor === color && (
            <Check
              color='white'
              size={20}
              className={cn(" ease-in-out duration-200")}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default DefaultColors;
